import { CommonModule } from '@angular/common';
import { Component, OnDestroy, effect, inject } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';

import { ToggleSwitchModule } from 'primeng/toggleswitch';
import { Subject } from 'rxjs';

import { DarkModeService } from '@services/dark-mode.service';

@Component({
  selector: 'bk-dark-mode-toggle',
  imports: [FormsModule, CommonModule, ToggleSwitchModule, ReactiveFormsModule],
  templateUrl: './dark-mode-toggle.component.html',
  styleUrl: './dark-mode-toggle.component.scss',
})
export class DarkModeToggleComponent implements OnDestroy {
  private destroy$ = new Subject<void>();
  darkModeService = inject(DarkModeService);
  formGroup = new FormGroup({
    darkMode: new FormControl(),
  });

  constructor() {
    effect(() => {
      const darkMode = this.darkModeService.darkMode();
      this.formGroup.setValue({ darkMode });
    });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
